import React from "react";
import { Avatar, Box, Paper, Typography } from "@mui/material";

import { maskPhoneNumber } from "../utils/studentDetailsHelpers";
import styles from "../StudentDetails.module.scss";

const StudentInfoCard = ({ studentData, phone }) => {
  const {
    first_name,
    last_name,
    uam_id,
    phone: responsePhone,
    admission_number,
    grade_id,
  } = studentData;

  const fullName = [first_name, last_name].filter(Boolean).join(" ") || "-";
  const initials =
    [first_name, last_name]
      .filter(Boolean)
      .map((name) => name.charAt(0))
      .join("")
      .slice(0, 2)
      .toUpperCase() || "ST";
  const maskedPhone = maskPhoneNumber(responsePhone || phone);

  const summaryFields = [
    { label: "First Name", value: first_name || "-" },
    { label: "Last Name", value: last_name || "-" },
    { label: "UAM ID", value: uam_id || "-" },
    { label: "Admission No / Username", value: admission_number || "-" },
    { label: "Masked Phone", value: maskedPhone || "-" },
    { label: "Grade", value: grade_id ? `Grade ${grade_id}` : "-" },
  ];

  return (
    <Paper elevation={0} className={styles.studentInfoPaper}>
      <Box className={styles.studentProfileHeader}>
        <Avatar className={styles.studentAvatar}>{initials}</Avatar>
        <Box>
          <Typography component="h3" className={styles.studentName}>
            {fullName}
          </Typography>
          <Typography className={styles.studentMeta}>
            {uam_id || "UAM ID unavailable"}
          </Typography>
        </Box>
      </Box>

      <Box className={styles.studentInfoGrid}>
        {summaryFields.map((field) => (
          <Box key={field.label} className={styles.studentInfoField}>
            <Typography className={styles.fieldLabel}>
              {" "}
              {field.label}{" "}
            </Typography>
            <Typography className={styles.fieldValue}>{field.value}</Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default StudentInfoCard;
